import { render } from "./Roles.vue?vue&type=template&id=004da9f9"
import script from "./Roles.vue?vue&type=script&lang=js"
export * from "./Roles.vue?vue&type=script&lang=js"

import "./Roles.vue?vue&type=style&index=0&id=004da9f9&lang=css"

import exportComponent from "D:\\Trabajo\\Raxar\\backoffice-base-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__